import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as GlobalActions from "../../actions";
import * as Actions from "./store/actions";
import ActionTypes from "../../constants";
import * as Apis from "./apis";
import { wrapByLoader, wrapWithoutLoader } from "../../utils";

const fetchRejectedBusinessPartners = action =>
  wrapByLoader(function*() {
    try {
      const response = yield call(Apis.fetchRejectedBPApi, action.payload);
      if (!response.error) {
        const rejectedBPlist = response.data.businessPartner;
        const pageInfo = response.data.pageInfo;
        yield put(Actions.fetchRejectedBPSucceeded(rejectedBPlist, pageInfo));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

export default [
  takeLatest(
    ActionTypes.FETCH_REJECTED_BUSINESS_PARTNERS,
    fetchRejectedBusinessPartners
  )
];
